<template>
    <hts-modal v-model="cVisible">
        <div v-loading="loading">
            <div>
                <label>
                    Thời gian chờ tối đa khi đi trực tiếp từ chặng trước tới chặng sau:
                </label>
                <hts-form-input
                    v-model="settingData.maxWaitingTime"
                    :min="0"
                    placeholder=""
                    type="number">
                    <template #suffix>
                        giờ
                    </template>
                </hts-form-input>
            </div>
            <hts-divider />
            <div>
                <div>
                    <label>
                        Điều phối lần 1 bắt đầu từ:
                    </label>
                    <hts-form-input
                        v-model="settingData.start"
                        :min="0"
                        :max="settingData.end"
                        placeholder=""
                        type="number">
                        <template #suffix>
                            giờ
                        </template>
                    </hts-form-input>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <label>
                            Cho các chặng có thời gian khởi hành sau đến sau >> đến
                        </label>
                        <hts-form-input
                            v-model="settingData.startRange1"
                            :min="0"
                            :max="settingData.startRange2"
                            placeholder=""
                            type="number"
                            class="mb-1">
                            <template #suffix>
                                giờ
                            </template>
                        </hts-form-input>
                        <span class="font-medium">
                            {{ $formatters.datetime(today.hour(settingData.start + settingData.startRange1).valueOf()) }}
                        </span>
                    </div>
                    <div>
                        <label>
                            đến sau
                        </label>
                        <hts-form-input
                            v-model="settingData.startRange2"
                            :min="settingData.startRange1"
                            :max="23"
                            placeholder=""
                            type="number"
                            class="mb-1">
                            <template #suffix>
                                giờ
                            </template>
                        </hts-form-input>
                        <span class="font-medium">
                            {{ $formatters.datetime(today.hour(settingData.start + settingData.startRange2).valueOf()) }}
                        </span>
                    </div>
                </div>
            </div>
            <hts-divider />
            <div>
                <div>
                    <label>
                        Điều phối lần 2 vào:
                    </label>
                    <hts-form-input
                        v-model="settingData.end"
                        :min="settingData.start + 1"
                        :max="23"
                        placeholder=""
                        type="number"
                        class="mb-1">
                        <template #suffix>
                            giờ
                        </template>
                    </hts-form-input>
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <label>
                            Cho các chặng có thời gian khởi hành sau đến sau >> đến
                        </label>
                        <hts-form-input
                            v-model="settingData.endRange1"
                            disabled
                            placeholder=""
                            type="number"
                            class="mb-1">
                            <template #suffix>
                                giờ
                            </template>
                        </hts-form-input>
                        <span class="font-medium">
                            {{ $formatters.datetime(today.hour(settingData.end + settingData.endRange1).valueOf()) }}
                        </span>
                    </div>
                    <div>
                        <label>
                            đến sau
                        </label>
                        <hts-form-input
                            v-model="settingData.endRange2"
                            disabled
                            placeholder=""
                            type="number">
                            <template #suffix>
                                giờ
                            </template>
                        </hts-form-input>
                        <span class="font-medium">
                            {{ $formatters.datetime(today.hour(settingData.end + settingData.endRange2).valueOf()) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="flex justify-between items-center">
                <hts-form-button
                    class="mt-4"
                    color="primary"
                    :loading="updating"
                    @click="updateSettings">
                    {{ $t('labels.save') }}
                </hts-form-button>
                <hts-form-button
                    class="mt-4"
                    :loading="reseting"
                    @click="resetAll">
                    {{ $t('labels.reset') }}
                </hts-form-button>
            </div>
        </div>
    </hts-modal>
</template>
<script lang="ts" setup>
const { $dayjs } = useNuxtApp()
/** Define & variables */
const { system } = $store()
const today = $dayjs().minute(0).second(0)
const loading = ref(false)
const updating = ref(false)
const reseting = ref(false)
const resetAll = () => {
  reseting.value = true
  $api($url.journey.schedule.setting.reset).then(() => {
    reseting.value = false
  })
}
const cVisible = ref(false)
const settingData = reactive({
  maxWaitingTime: 4,
  start: 9,
  startRange1: 7,
  startRange2: 17,
  end: 16,
  endRange1: 10,
  endRange2: 24
})

/** Watching */
watch(
  () => settingData.start,
  (val) => {
    settingData.endRange1 = settingData.start + settingData.startRange2 - settingData.end
    settingData.endRange2 = settingData.start + settingData.startRange1 + (24 - settingData.end)
  }
)
watch(
  () => settingData.end,
  (val) => {
    settingData.endRange1 = settingData.start + settingData.startRange2 - settingData.end
    settingData.endRange2 = settingData.start + settingData.startRange1 + (24 - settingData.end)
  }
)
watch(
  () => settingData.startRange1,
  (val) => {
    settingData.endRange2 = settingData.start + settingData.startRange1 + (24 - settingData.end)
  }
)
watch(
  () => settingData.startRange2,
  (val) => {
    settingData.endRange1 = settingData.start + settingData.startRange2 - settingData.end
  }
)

/** Methods */
const getSettings = () => {
  loading.value = true
  $api($url.journey.schedule.setting.get).then(({ data }) => {
    const temp = (data?.value || {}).data || {}
    Object.assign(settingData, temp)
    loading.value = false
  })
}

const updateSettings = () => {
  updating.value = true
  $api($url.journey.schedule.setting.update, { body: settingData })
    .then(({ data }) => {
      const temp = (data?.value || {}).data || {}
      Object.assign(settingData, temp)
      system.setScheduleSettings(settingData)
      updating.value = false
      hide()
    })
    .catch(() => {
      updating.value = false
    })
}

/** Utils */
const show = () => {
  getSettings()
  cVisible.value = true
}
const hide = () => {
  nextTick(() => {
    cVisible.value = false
  })
}
defineExpose({ show, hide })
</script>
